import React, { useState, useEffect } from 'react';
import logo from './media/knowwinn_n.svg';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import PackagingPage from './pages/PackagingPage';
import SolicitudPackagingPage from './pages/SolicitudPackagingPage';
import LoginPage from './pages/LoginPage';
import MarketingPage from './pages/MarketingPage';   // crea este archivo
import AdminPage from './pages/AdminPage';           // crea este archivo
import './App.css';
import './Boton.css';

function App({ modalRoot }) {
  const [usuario, setUsuario] = useState(() => {
    const storedUser = localStorage.getItem('usuario');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  useEffect(() => {
    if (usuario) {
      localStorage.setItem('usuario', JSON.stringify(usuario));
    } else {
      localStorage.removeItem('usuario');
    }
  }, [usuario]);

  const handleLogout = () => setUsuario(null);

  // Función para renderizar navegación según rol
  const renderNav = () => {
    if (!usuario) return null;

    let links = [];

    if (usuario.role === 'packaging' || usuario.role === 'admin' || usuario.role === 'marketing') {
      links.push(<Link key="packaging" to="/">PACKAGING</Link>);
    }

    if (usuario.role === 'packaging' || usuario.role === 'admin') {
      links.push(<Link key="solicitud" to="/solicitud">SOLICITUD</Link>);
    }

    if (usuario.role === 'marketing' || usuario.role === 'admin') {
      links.push(<Link key="marketing" to="/marketing">MARKETING</Link>);
    }

    if (usuario.role === 'admin') {
      links.push(<Link key="admin" to="/admin">ADMIN</Link>);
    }


    return <div className="nav-content">{links}</div>;
  };

  return (
    <Router>
      <div className="App">
        {usuario && (
          <header className="header-top">
            <div className="logo-container-app">
              <img src={logo} className="App-logo" alt="logo" />
            </div>

            <div className="right-header">
              <div className="bienvenida-container">
                <p className="bienvenida">Bienvenido, {usuario.username}!</p>
                <button onClick={handleLogout} className="boton peligro little a">logout</button>
              </div>
              <nav className="nav">{renderNav()}</nav>
            </div>
          </header>
        )}

        <div className="main-content">
          <Routes>
            <Route path="/login" element={<LoginPage onLogin={setUsuario} />} />

            {/* Ruta para '/' que permite packaging, marketing y admin */}
            <Route
              path="/"
              element={
                usuario && (usuario.role === 'packaging' || usuario.role === 'admin' || usuario.role === 'marketing') ? (
                  <PackagingPage modalRoot={modalRoot} />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/solicitud"
              element={
                usuario?.role === 'packaging' || usuario?.role === 'admin' ? (
                  <SolicitudPackagingPage />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/marketing"
              element={
                usuario?.role === 'marketing' || usuario?.role === 'admin' ? (
                  <MarketingPage />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/admin"
              element={
                usuario?.role === 'admin' ? <AdminPage /> : <Navigate to="/login" />
              }
            />

            {/* Redirigir a login si la ruta no existe */}
            <Route path="*" element={<Navigate to={usuario ? "/" : "/login"} />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
